import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { NgPipesModule } from 'ngx-pipes'

import { LocaleModule } from 'common/locale/module'
import { UtilCommonModule } from 'common/util/module'

import { CreateClickLinkModalComponent } from './components/createClickLinkModal.component'
import { CreateClickGalleryModalComponent } from './components/createClickGalleryModal.component'
import { ClickSharingModalComponent } from './components/clickSharingModal.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    UtilCommonModule,
    NgPipesModule,
    LocaleModule.forChild(),
  ],
  declarations: [
    ClickSharingModalComponent,
    CreateClickLinkModalComponent,
    CreateClickGalleryModalComponent,
  ],
  exports: [
    ClickSharingModalComponent,
  ],
})
export class ClickModule { }
